import { render, staticRenderFns } from "./strDeta.vue?vue&type=template&id=233c7030&scoped=true&"
import script from "./strDeta.vue?vue&type=script&lang=js&"
export * from "./strDeta.vue?vue&type=script&lang=js&"
import style0 from "./strDeta.vue?vue&type=style&index=0&id=233c7030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233c7030",
  null
  
)

export default component.exports